import { useEffect, useState } from 'react';

import { getAllFornecedores } from '../fornecedoresDAF/fornecedorService';
// ajuste o import acima conforme o tipo real do fornecedor no projeto

let fornecedoresCache: any[] | null = null;

export function getFornecedoresMemoryCache() {
  return fornecedoresCache;
}

export function setFornecedoresMemoryCache(data: any[]) {
  fornecedoresCache = data;
}

export function clearFornecedoresMemoryCache() {
  fornecedoresCache = null;
}

export function useFornecedoresCache() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cached = getFornecedoresMemoryCache();
    if (cached) {
      setData(cached);
      return;
    }

    setLoading(true);
    getAllFornecedores()
      .then((result) => {
        setData(result);
        setFornecedoresMemoryCache(result);
      })
      .finally(() => setLoading(false));
  }, []);

  return { data, loading };
}
